import React from "react";
import ServiceCard from "@/components/ServiceCard";
import { CATEGORY_IMAGES, getServiceImage } from "@/data/serviceImages";

// Homepage "What We Do" grid. All imagery now resolves through the central
// service-image registry so we stay consistent with the service detail pages
// and with any rebrands or BR project photo swaps later.
const SERVICE_CARDS = [
  {
    eyebrow: "Exterior",
    title: "Roofing",
    description: "Inspections, repairs, replacements, and storm follow-up.",
    to: "/roofing",
    image: CATEGORY_IMAGES.roofing,
  },
  {
    eyebrow: "Interior",
    title: "Remodeling",
    description: "Kitchens, baths, full home, and finish work.",
    to: "/remodeling",
    image: CATEGORY_IMAGES.remodeling,
  },
  {
    eyebrow: "Feature",
    title: "Interior Feature Upgrades",
    description:
      "Accent walls, electric fireplace feature walls, TV centers, media walls, built-ins, and custom trim details that give your home a high-impact upgrade without a full remodel.",
    to: "/services/interior-feature-upgrades",
    image: getServiceImage("interior-feature-upgrades"),
    ctaLabel: "View Interior Feature Upgrades",
  },
  {
    eyebrow: "Build",
    title: "Home Additions",
    description: "Add the space your home needs — done right.",
    to: "/services/home-additions",
    image: getServiceImage("home-additions"),
  },
  {
    eyebrow: "Outside",
    title: "Outdoor Living",
    description: "Patios, decks, pergolas, and outdoor kitchens.",
    to: "/services/outdoor-living",
    image: getServiceImage("outdoor-living"),
  },
  {
    eyebrow: "Ongoing",
    title: "Maintenance Plans",
    description: "Recurring home care with defined covered work.",
    to: "/maintenance-plans",
    image: getServiceImage("home-maintenance-plans"),
  },
  {
    eyebrow: "Fixes",
    title: "Repair & Punch List",
    description: "Real GC handling your list of small things.",
    to: "/services/handyman-punch-list",
    image: getServiceImage("handyman-punch-list"),
  },
  {
    eyebrow: "Investor",
    title: "Investor Property Repairs",
    description: "Make-ready, turnover, portfolio maintenance.",
    to: "/services/investor-property-repairs",
    image: getServiceImage("investor-property-repairs"),
  },
  {
    eyebrow: "Partners",
    title: "Subcontractor Partnerships",
    description: "Trade partners can apply to join our network.",
    to: "/subcontractor-partnerships",
    image: CATEGORY_IMAGES["subcontractor-partnerships"],
  },
];

export default function HomeServicesOverview() {
  return (
    <section className="section-pad bg-br-paper">
      <div className="container-br">
        <div className="max-w-2xl mb-10">
          <div className="br-eyebrow">What We Do</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">
            Roofing, Remodeling, Repairs &amp; Maintenance — Under One Roof
          </h2>
          <p className="mt-3 text-gray-700">
            Black Ridge Construction operates as a real general contractor for
            Central Texas homeowners. Below are the project types we handle most often.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICE_CARDS.map((card) => (
            <ServiceCard key={card.title} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
}
